import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import About from './pages/About';
import Portfolio from './pages/Portfolio';
import Contact from './pages/Contact';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import ServicePage from './pages/ServicePage';
import FreeConsultation from './pages/FreeConsultation';
import ProblemPage from './pages/ProblemPage';
import CaseStudies from './pages/CaseStudies';
import CaseStudy from './pages/CaseStudy';
import { Toaster } from './components/ui/toaster';
import ScrollToTop from './components/ScrollToTop';

function App() {
  return (
    <div className="App bg-[#0b0b0d] text-white min-h-screen">
      <BrowserRouter>
        <ScrollToTop />
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/case-studies" element={<CaseStudies />} />
            <Route path="/case-studies/:slug" element={<CaseStudy />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/marketing-agency-liverpool/:slug" element={<BlogPost />} />
            <Route path="/video-production-liverpool/:slug" element={<BlogPost />} />
            <Route path="/improve-public-awareness" element={<ProblemPage />} />
            <Route path="/losing-staff" element={<ProblemPage />} />
            <Route path="/competing-on-price" element={<ProblemPage />} />
            <Route path="/public-sector" element={<ProblemPage />} />
            <Route path="/free-marketing-health-check" element={<FreeConsultation />} />
            <Route path="/free-marketing-consultation" element={<Navigate to="/free-marketing-health-check" replace />} />
            <Route path="/:slug" element={<ServicePage />} />
          </Routes>
        </Layout>
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
